import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { organizationService } from '../services/organizationService';
import { Role } from '../types';

export const useUserRole = () => {
  const { user } = useAuth();
  const [role, setRole] = useState<Role | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkRole = async () => {
      if (!user?.id || !user.organizationId) {
        setRole(null);
        setLoading(false);
        return;
      }

      try {
        const isAdmin = await organizationService.isUserAdmin(user.organizationId, user.id);
        setRole(isAdmin ? 'Admin' : 'User');
      } catch (error) {
        console.error('Error checking user role:', error);
        setRole(null);
      } finally {
        setLoading(false);
      }
    };

    checkRole();
  }, [user]);

  return { role, loading };
};

export default useUserRole;